<template>
	<div class="box-error">
		<div class="header">
			<strong>Error!</strong>
			<button v-if="details" @click.stop.prevent="onClick">Details</button>
		</div>
		<div class="body">
			<slot></slot>
			<div class="message">{{ message }}</div>
			<div class="details" v-if="details" v-show="show_details">{{ details }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'error'
	],
	data () {
		return {
			show_details: false
		}
	},
	computed: {
		message () {
			if (this.error && this.error.body && this.error.body.message)
				return this.error.body.message
			else
				return ''
		},
		details () {
			return this.error
		}
	},
	methods: {
		onClick () {
			this.show_details = !this.show_details
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/boxes/ErrorBox.vue